import React from 'react';
import Add from '../../../assets/images/SurveyBulkAdd.svg';
import { pulseSurveyPageData } from '../../../utils/pageContent';

const BulkAnswerModal = ({
  bulkAnswerInput,
  handleGetBulkAnswerData,
  maxLength,
  handleSaveBulkAnswer
}) => {
  const modalData = pulseSurveyPageData.bulkAnswerModalData;
  return (
    <div className="flex justify-center items-center z-50 fixed h-screen w-screen top-0 left-0 bg-black/15 px-10">
      <div className=" h-fit w-[702px] rounded-[24px] sm:px-16 px-6 py-4 bg-shoorah-normanGray dark:bg-shoorah-darkBgTabColor">
        <div className="text-shoorah-lightBlack dark:text-shoorah-darkBg sm:text-4xl text-2xl mt-[16px]">{modalData.title}</div>
        <div className="text-shoorah-lightBlack dark:text-shoorah-darkBg sm:text-[18px] text-[16px] font-thin mt-[10px] flex">
          {modalData.description}
        </div>
        <div className="flex justify-center mt-[30px]">
          <div className="relative w-full">
            <div className="absolute left-4 top-4">
              <image src={Add} alt="Add" />
            </div>
            <textarea
              value={bulkAnswerInput}
              onChange={(e) => handleGetBulkAnswerData(e)}
              maxLength={maxLength}
              placeholder="Enter reason here..."
              className="w-full h-[240px] pt-3 sm:pl-12 px-6 border rounded-2xl resize-none text-shoorah-lightBlack dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor border-shoorah-borderGray focus:outline-none dark:border-shoorah-darkBorder"
            />
            <div className="absolute bottom-2 right-4 py-5 sm:px-6 px-4 text-gray-400 text-sm">
              *{maxLength} {modalData.characterLimitText}
            </div>
          </div>
        </div>
        <div className="flex justify-end mt-[40px] mb-[10px] gap-6">
          <button
            className="text-black border dark:border-shoorah-darkBg dark:text-shoorah-darkBg border-black px-10  rounded-full p-3"
            onClick={() => handleSaveBulkAnswer('cancel')}
          >
            {modalData.cancelBtnText}
          </button>
          <button
            className="btn-primary"
            onClick={() => handleSaveBulkAnswer('save')}
          >
            {modalData.saveBtnText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkAnswerModal;
